import React from "react";
import { Link } from "react-router-dom";

export default function CountTotalDataBox({ countData }) {
  return (
    <>
      <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
        <Link to={`/${countData.redirect_link}`}>
          <div className="ui-item">
            <div className="left">
              <i
                className={`icon ${countData.icon}`}
                style={{ color: countData.color }}
                aria-hidden="true"
              ></i>
            </div>
            <div className="right">
              <h4 style={{ color: countData.color }}>{countData.counter}</h4>
              <p>{countData.name}</p>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
}
